const styleTags: HTMLLinkElement[] = [];

export function getStyleTags() {
  return styleTags.map((node) => node.cloneNode(true)) as HTMLLinkElement[];
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (linkTag: HTMLLinkElement) {
  styleTags.push(linkTag);
}
